import React, { useEffect, useState } from 'react';
import '../../assets/css/custom.css';

const TextRotator = ({ texts = [], period = 4000 }) => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [delta, setDelta] = useState(250); // typing speed

  useEffect(() => {
    const i = loopNum % texts.length;
    const fullText = texts[i];

    const handleTyping = () => {
      setText(prev => {
        const updated = isDeleting
          ? fullText.substring(0, prev.length - 1)
          : fullText.substring(0, prev.length + 1);
        return updated;
      });

      // Adjust typing/deleting speed
      if (isDeleting) {
        setDelta(150); // slower delete
      } else {
        setDelta(250); // slower type
      }

      // When word is fully typed
      if (!isDeleting && text === fullText) {
        setTimeout(() => setIsDeleting(true), period);
      }

      // When word is fully deleted
      if (isDeleting && text === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
      }
    };

    const timer = setTimeout(handleTyping, delta);
    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, texts, delta, period]);

  return (
    <span className="txt-rotate">
      <span className="t-wrap txt-rotate-landing">{text}</span>
      <span className="t-cursor">|</span>
    </span>
  );
};

export default TextRotator;
